



















































































import Vue from 'vue';
import { gridSize } from '@/theme/constants';

export default Vue.extend({
  name: 'ALDialog',

  props: {
    value: { type: Boolean },
    title: { type: String, default: () => '' },
    subTitle: { type: String, default: () => '' },
    loading: { type: Boolean },
    fullscreen: { type: Boolean },
    disableOnLoading: { type: Boolean },
    hideHeader: { type: Boolean },
    noCardTextPadding: { type: Boolean, default: false }
  },

  computed: {
    internalValue: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit('input', value);
      }
    },

    defaultClass(): string {
      if (!this.hasDefaultSlot) return 'py-2';

      return 'my-2 pb-6 pt-2';
    },
    titleWrapperStyles(): Record<string, any> {
      return {
        flexWrap: `nowrap`,
        flex: 1
      };
    },

    titleContainerStyles(): Record<string, any> {
      return {
        minWidth: 0,
        maxWidth: '100%',
        marginBottom: `${this.hasSubtitle ? gridSize() : 0}px`,
        flexShrink: undefined
      };
    },

    styledTitleStyles(): Record<string, any> {
      return {
        marginTop: 0,
        lineHeight: `${gridSize() * 4.82}px`,
        outline: 'none'
      };
    },

    styledSubTitleStyles(): Record<string, any> {
      return {
        lineHeight: `${gridSize() * 2}px`,
        outline: 'none'
      };
    },

    hasSubtitle(): boolean {
      return !!this.subTitle || !!this.$slots['subtitle'];
    },

    hasDefaultSlot(): boolean {
      return !!this.$slots['default'];
    },

    hasActionsSlot(): boolean {
      return !!this.$slots['actions'];
    },

    hasBottomSlot(): boolean {
      return !!this.$slots['bottom'];
    },

    bottomStyles(): Record<string, string> {
      return { padding: '12px 24px 12px', 'column-gap': '4px' };
    },

    actionCSSStyles(): Record<string, any> {
      return {
        maxWidth: '100%',
        marginBottom: 'auto',
        marginLeft: 'auto',
        paddingLeft: `${gridSize() * 2}px`,
        flex: '0 0 auto',
        whiteSpace: 'nowrap',
        '>': {
          textAlign: 'right'
        }
      };
    },

    actionStyles(): Record<string, any> {
      if (!this.hasActionsSlot) return {};

      return this.actionCSSStyles;
    }
  },

  methods: {
    close() {
      this.$emit('close');
    }
  }
});
